module.exports = __webpack_public_path__ + "static/media/chair.07910b98.png";